import baseURL from '../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { trimData } from '../utilities/TrimPayloadData.js';
import { loadingAction } from '../redux/actions/loadingAction';
import handleRefreshToken from './RefreshToken.js';

export const handlePutRequest =
    (data, url, isShowLoad = false, isShowToast = true) =>
    async (dispatch) => {
        if (!(data instanceof FormData)) {
            data = await trimData(data);
        }
        try {
            const loginData = JSON.parse(localStorage.getItem('user'));
            const accessToken = loginData?.data?.token;
            if (isShowLoad) dispatch(loadingAction(true));
            const response = await axios({
                method: 'put',
                url: `${baseURL + url}`,
                data: data,
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${accessToken}`
                }
            });
            if (isShowToast) toast.success(response?.data?.message, { autoClose: 1000 });
            if (isShowLoad) dispatch(loadingAction(false));
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                const newToken = await handleRefreshToken();
                if (newToken) {
                    return await handlePutRequest(data, url, isShowLoad, isShowToast)(dispatch);
                } else {
                    localStorage.clear();
                    window.location.href = '/';
                    toast.error('Session expired. Please log in again.');
                    return;
                }
            }
            if (isShowLoad) dispatch(loadingAction(false));
            if (error?.response?.status === 400 || error?.response?.status === 500) {
                toast.warn(error?.response?.data?.messages || error?.response?.data?.message || 'Something went wrong !!');
            } else {
                toast.warn(error?.response?.data?.messages || error?.response?.data?.message || 'Something went wrong !!');
            }

            return error?.response;
        }
    };
